import {lazy} from '@aboutyou/lazy-imports';

export const SizeGroups = lazy(() =>
  import('./SizeGroups.eager').then(mod => ({default: mod.SizeGroups})),
);
